const URL_PATTERN = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi

export interface TextPart {
  text: string
  href?: string
}

/**
 * Splits item text into plain and linked parts. The caller renders these as
 * text nodes and anchors, so nothing a user types is ever treated as markup.
 */
export function linkify(text: string): TextPart[] {
  const parts: TextPart[] = []
  let cursor = 0
  for (const match of text.matchAll(URL_PATTERN)) {
    const start = match.index ?? 0
    let raw = match[0]
    // Trailing punctuation is almost never part of the link.
    const trailing = /[.,;:!?)\]]+$/.exec(raw)
    if (trailing) raw = raw.slice(0, raw.length - trailing[0].length)
    if (!raw) continue
    if (start > cursor) parts.push({ text: text.slice(cursor, start) })
    parts.push({ text: raw, href: raw.startsWith('http') ? raw : `https://${raw}` })
    cursor = start + raw.length
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor) })
  return parts.length > 0 ? parts : [{ text }]
}
